var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManageBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 25,
    height: 16,
    rx: 2,
    stroke: "#275CE6",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.549 15V14C13.549 13.4696 13.3206 12.9609 12.914 12.5858C12.5075 12.2107 11.9561 12 11.3812 12H7.58766C7.01274 12 6.46137 12.2107 6.05484 12.5858C5.64831 12.9609 5.41992 13.4696 5.41992 14V15",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93536 10C10.933 10 11.7418 9.10457 11.7418 8C11.7418 6.89543 10.933 6 9.93536 6C8.93768 6 8.12891 6.89543 8.12891 8C8.12891 9.10457 8.93768 10 9.93536 10Z",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9H25",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H22",
    stroke: "#275CE6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManageBlue);
export default __webpack_public_path__ + "static/media/userManage_blue.64cbc0b849c81831e83a1efed2a2bd44.svg";
export { ForwardRef as ReactComponent };